<script>
    import AppLayout from "../components/shared/AppLayout.svelte";
    import PageHeader from "../components/shared/MainHeader.svelte";
    import InstitutionalHeader from "../components/institutional_insights/InstitutionalHeader.svelte";
    import InsitutionalTrialsLanding from "../components/institutional_insights/InsitutionalTrialsLanding.svelte";
</script>

<div>
    <PageHeader/>
    <AppLayout subHeader="{InstitutionalHeader}" mainContent="{InsitutionalTrialsLanding}"/>
</div>


